import { goRequest } from '../utils/httpClientTs';
import {
  TLCListParams,
  TLCListResponse,
  TLCDetailResponse,
  TLCPatchRequest,
  TLCChapterPostRequest,
  TLCMemberPostRequest,
  TLCMemberPatchRequest,
  TLCMemberReplaceRequest,
} from '../types/tlc';
import { GenericResponse } from '../types/generic';

export const getTLCList = async (
  params: TLCListParams
): Promise<TLCListResponse> => {
  let url = `/tlc?page_size=${params.page_size}&page=${params.page}`;

  if (params.search) {
    url += `&search=${encodeURIComponent(params.search)}`;
  }
  if (params.order_by) {
    url += `&order_by=${params.order_by}`;
  }
  if (params.order) {
    url += `&order=${params.order}`;
  }
  if (params.spd) {
    url += `&spd=${encodeURIComponent(params.spd)}`;
  }

  return goRequest<TLCListResponse>({
    url: url,
    method: 'GET',
  });
};

export const getTLCDetail = async (id: string): Promise<TLCDetailResponse> => {
  return goRequest<TLCDetailResponse>({
    url: `/tlc/${id}`,
    method: 'GET',
  });
};

export const updateTLC = async (
  id: string,
  data: TLCPatchRequest
): Promise<GenericResponse> => {
  return goRequest<GenericResponse>({
    url: `/tlc/${id}`,
    method: 'PATCH',
    data: data,
  });
};

export const createTLCChapter = async (
  tlcId: string,
  data: TLCChapterPostRequest
): Promise<GenericResponse> => {
  return goRequest<GenericResponse>({
    url: `/tlc/${tlcId}/chapters`,
    method: 'POST',
    data: data,
  });
};

export const deleteTLCChapter = async (
  tlcId: string,
  chapterId: string
): Promise<GenericResponse> => {
  return goRequest<GenericResponse>({
    url: `/tlc/${tlcId}/chapters/${chapterId}`,
    method: 'DELETE',
  });
};

export const createTLCMember = async (
  tlcId: string,
  data: TLCMemberPostRequest
): Promise<GenericResponse> => {
  return goRequest<GenericResponse>({
    url: `/tlc/${tlcId}/members`,
    method: 'POST',
    data: data,
  });
};

export const updateTLCMember = async (
  tlcId: string,
  memberId: string,
  data: TLCMemberPatchRequest
): Promise<GenericResponse> => {
  return goRequest<GenericResponse>({
    url: `/tlc/${tlcId}/members/${memberId}`,
    method: 'PATCH',
    data: data,
  });
};

export const deleteTLCMember = async (
  tlcId: string,
  memberId: string
): Promise<GenericResponse> => {
  return goRequest<GenericResponse>({
    url: `/tlc/${tlcId}/members/${memberId}`,
    method: 'DELETE',
  });
};

export const replaceTLCMember = async (
  tlcId: string,
  memberId: string,
  data: TLCMemberReplaceRequest
): Promise<GenericResponse> => {
  return goRequest<GenericResponse>({
    url: `/tlc/${tlcId}/members/${memberId}/replace`,
    method: 'POST',
    data: data,
  });
};
